// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GlobeHemisphereWestIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3Zm11 13c.001 1.411-.27 2.81-.8 4.117l-5.587-3.436a1.992 1.992 0 0 0-.78-.279l-2.853-.385a2.013 2.013 0 0 0-2 .983h-1.09l-.475-.983a1.988 1.988 0 0 0-1.375-1.083l-1-.216.978-1.718h2.088c.338 0 .67-.087.966-.25l1.532-.845c.134-.075.26-.165.375-.268l3.364-3.042a1.991 1.991 0 0 0 .407-2.458l-.045-.08A11.013 11.013 0 0 1 27 16ZM17.914 5.168 19 7.112l-3.364 3.043-1.53.845h-2.088a2 2 0 0 0-1.736 1l-1.09 1.904-1.27-3.38L9.29 7.29a10.984 10.984 0 0 1 8.625-2.125l-.001.003ZM5 16a10.941 10.941 0 0 1 1.068-4.725l1.417 3.784a2 2 0 0 0 1.453 1.25l2.678.576.476.99a2.011 2.011 0 0 0 1.8 1.125h.186l-.904 2.029a2 2 0 0 0 .357 2.171l.018.018L16 25.742l-.242 1.25A11.014 11.014 0 0 1 5 16Zm12.823 10.848.14-.727a2.013 2.013 0 0 0-.517-1.755L15 21.843 16.712 18l2.853.385L25.28 21.9a11.023 11.023 0 0 1-7.457 4.948Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
